import type { ComponentProps } from 'react'
import SearchForm from 'components/Search/SearchForm'
import { HOTEL_SEARCH_TYPEAHEAD_TYPES } from 'constants/search'
import useLocationSearchLabels from 'hooks/Search/useLocationSearchLabels'

type Props = Omit<ComponentProps<typeof SearchForm>, 'label' | 'locationSearchPlaceholder' | 'showNaturalLanguageSearchSuggestions' | 'typeaheadTypes'>

function HotelSearchForm(props: Props) {
  const locationLabels = useLocationSearchLabels()

  return <SearchForm
    {...props}
    typeaheadTypes={HOTEL_SEARCH_TYPEAHEAD_TYPES}
    locationSearchPlaceholder={locationLabels.placeholderLabelNaturalLanguage}
    label={locationLabels.titleLabelNaturalLanguage}
    showNaturalLanguageSearchSuggestions
  />
}

export default HotelSearchForm
